import React, { useState } from 'react';
import { login } from '../api';
import logo from '../LinchpinCRTLOGOfinal.png';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showReset, setShowReset] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetSent, setResetSent] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  // New password challenge state
  const [challenge, setChallenge] = useState(null); // { session, email }
  const [newPassword, setNewPassword] = useState('');
  const [confirmNew, setConfirmNew] = useState('');

  const requirements = [
    { label: '8+ characters', met: newPassword.length >= 8 },
    { label: 'Uppercase letter', met: /[A-Z]/.test(newPassword) },
    { label: 'Lowercase letter', met: /[a-z]/.test(newPassword) },
    { label: 'Number', met: /[0-9]/.test(newPassword) },
    { label: 'Special character', met: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(newPassword) },
  ];
  const allMet = requirements.every(r => r.met);

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const data = await login(email.toLowerCase().trim(), password);
      if (data.error) {
        setError(data.error);
        setLoading(false);
        return;
      }
      if (data.challenge === 'NEW_PASSWORD_REQUIRED') {
        setChallenge({ session: data.session, email: data.email });
        setLoading(false);
        return;
      }
      localStorage.setItem('access_token', data.access_token);
      localStorage.setItem('refresh_token', data.refresh_token);
      localStorage.setItem('token', JSON.stringify(data.user));
      window.location.href = '/dashboard';
    } catch (err) {
      setError('Something went wrong. Please try again.');
      setLoading(false);
    }
  }

  async function handleNewPassword(e) {
    e.preventDefault();
    if (newPassword !== confirmNew) { setError('Passwords do not match.'); return; }
    if (!allMet) { setError('Please meet all password requirements.'); return; }
    setLoading(true);
    setError('');
    try {
      const data = await login(challenge.email, password, newPassword, challenge.session);
      if (data.error) { setError(data.error); setLoading(false); return; }
      localStorage.setItem('access_token', data.access_token);
      localStorage.setItem('token', JSON.stringify(data.user));
      window.location.href = '/dashboard';
    } catch (err) {
      setError('Something went wrong. Please try again.');
      setLoading(false);
    }
  }

  async function handleForgotPassword(e) {
    e.preventDefault();
    if (!resetEmail.trim()) return;
    setResetLoading(true);
    const result = await fetch('/auth/forgot-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: resetEmail.trim() })
    }).then(r => r.json());
    setResetLoading(false);
    if (result.error) { setError(result.error); return; }
    setResetSent(true);
  }

  // New password required screen
  if (challenge) {
    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <div style={styles.brand}>
            <div style={styles.logoBox}>
              <img src={logo} alt="LinchpinCRT" style={{ height: '48px', width: 'auto' }} />
            </div>
            <div>
              <div style={styles.productName}>LinchpinCRT</div>
              <div style={styles.tagline}>Set your password</div>
            </div>
          </div>
          <div style={styles.divider} />
          <p style={{ color: '#7A6E60', fontSize: '13px', marginBottom: '20px', lineHeight: 1.6 }}>
            Welcome! Please set a permanent password to continue.
          </p>
          <form onSubmit={handleNewPassword} style={styles.form}>
            <div style={styles.field}>
              <label style={styles.label}>New Password</label>
              <input style={styles.input} type="password" placeholder="Min 8 characters"
                value={newPassword} onChange={e => setNewPassword(e.target.value)}
                required disabled={loading}
                onFocus={e => e.target.style.borderColor = '#2563EB'}
                onBlur={e => e.target.style.borderColor = '#BEB3A4'} />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Confirm Password</label>
              <input style={styles.input} type="password" placeholder="Repeat password"
                value={confirmNew} onChange={e => setConfirmNew(e.target.value)}
                required disabled={loading}
                onFocus={e => e.target.style.borderColor = '#2563EB'}
                onBlur={e => e.target.style.borderColor = '#BEB3A4'} />
            </div>
            <div style={{ background: '#F5F0E8', border: '1px solid #BEB3A4', borderRadius: '8px', padding: '12px 14px' }}>
              {requirements.map((req, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: i < requirements.length - 1 ? '6px' : 0 }}>
                  <span style={{ fontSize: '12px', color: req.met ? '#15803D' : '#7A6E60' }}>{req.met ? '✓' : '○'}</span>
                  <span style={{ fontFamily: 'monospace', fontSize: '11px', color: req.met ? '#15803D' : '#7A6E60' }}>{req.label}</span>
                </div>
              ))}
              {confirmNew.length > 0 && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
                  <span style={{ fontSize: '12px', color: newPassword === confirmNew ? '#15803D' : '#B91C1C' }}>{newPassword === confirmNew ? '✓' : '✗'}</span>
                  <span style={{ fontFamily: 'monospace', fontSize: '11px', color: newPassword === confirmNew ? '#15803D' : '#B91C1C' }}>{newPassword === confirmNew ? 'Passwords match' : 'Do not match'}</span>
                </div>
              )}
            </div>
            {error && <div style={styles.error}>{error}</div>}
            <button type="submit" disabled={loading || !allMet || newPassword !== confirmNew}
              style={{ ...styles.btn, opacity: (loading || !allMet || newPassword !== confirmNew) ? 0.4 : 1 }}>
              {loading ? 'Setting password...' : 'Set Password & Log In'}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.brand}>
          <div style={styles.logoBox}>
            <img src={logo} alt="LinchpinCRT" style={{ height: '48px', width: 'auto' }} />
          </div>
          <div>
            <div style={styles.productName}>LinchpinCRT</div>
            <div style={styles.tagline}>{showReset ? 'Reset your password' : 'ENC Report Manager'}</div>
          </div>
        </div>
        <div style={styles.divider} />

        {showReset ? (
          resetSent ? (
            <div style={{ textAlign: 'center', padding: '10px 0' }}>
              <div style={{ fontSize: '32px', marginBottom: '12px' }}>📬</div>
              <div style={{ color: '#15803D', fontFamily: 'monospace', fontSize: '13px', fontWeight: '700', marginBottom: '8px' }}>Reset email sent!</div>
              <div style={{ color: '#7A6E60', fontSize: '12px', marginBottom: '20px', lineHeight: 1.6 }}>
                Check your inbox and click the link to set a new password.
              </div>
              <span onClick={() => { setShowReset(false); setResetSent(false); setResetEmail(''); }}
                style={{ color: '#2563EB', fontSize: '12px', fontFamily: 'monospace', cursor: 'pointer', textDecoration: 'underline' }}>
                ← Back to login
              </span>
            </div>
          ) : (
            <form onSubmit={handleForgotPassword} style={styles.form}>
              <div style={{ color: '#7A6E60', fontSize: '12px', lineHeight: 1.6, marginBottom: '4px' }}>
                Enter your email and we'll send you a link to reset your password.
              </div>
              <div style={styles.field}>
                <label style={styles.label}>Email</label>
                <input style={styles.input} type="email" placeholder="you@company.com"
                  value={resetEmail} onChange={e => setResetEmail(e.target.value)}
                  required disabled={resetLoading}
                  onFocus={e => e.target.style.borderColor = '#2563EB'}
                  onBlur={e => e.target.style.borderColor = '#BEB3A4'} />
              </div>
              {error && <div style={styles.error}>{error}</div>}
              <button type="submit" style={{ ...styles.btn, opacity: resetLoading ? 0.5 : 1 }} disabled={resetLoading}>
                {resetLoading ? 'Sending...' : 'Send Reset Link'}
              </button>
              <div style={{ textAlign: 'center' }}>
                <span onClick={() => { setShowReset(false); setError(''); }}
                  style={{ color: '#7A6E60', fontSize: '12px', fontFamily: 'monospace', cursor: 'pointer', textDecoration: 'underline' }}>
                  ← Back to login
                </span>
              </div>
            </form>
          )
        ) : (
          <form onSubmit={handleLogin} style={styles.form}>
            <div style={styles.field}>
              <label style={styles.label}>Email</label>
              <input style={styles.input} type="email" placeholder="you@company.com"
                value={email} onChange={e => setEmail(e.target.value)}
                required disabled={loading}
                onFocus={e => e.target.style.borderColor = '#2563EB'}
                onBlur={e => e.target.style.borderColor = '#BEB3A4'} />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Password</label>
              <input style={styles.input} type="password" placeholder="••••••••"
                value={password} onChange={e => setPassword(e.target.value)}
                required disabled={loading}
                onFocus={e => e.target.style.borderColor = '#2563EB'}
                onBlur={e => e.target.style.borderColor = '#BEB3A4'} />
            </div>
            {error && <div style={styles.error}>{error}</div>}
            <button type="submit" style={{ ...styles.btn, opacity: loading ? 0.5 : 1 }} disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
            <div style={{ textAlign: 'center', marginTop: '-6px' }}>
              <span onClick={() => { window.location.href = '/reset-password'; }}
                style={{ color: '#2563EB', fontSize: '12px', fontFamily: 'monospace', cursor: 'pointer', textDecoration: 'underline', opacity: 0.8 }}>
                Forgot password?
              </span>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: '#F5F0E8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'IBM Plex Sans', sans-serif",
  },
  card: {
    background: '#EDE7DD',
    border: '1px solid #BEB3A4',
    borderRadius: '12px',
    padding: '40px',
    width: '420px',
    boxShadow: '0 25px 50px rgba(0,0,0,0.6)',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '24px',
  },
  logoBox: {
    width: '52px', height: '52px',
    background: '#1B4F8A',
    borderRadius: '10px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  productName: {
    color: '#0F1C2E',
    fontFamily: 'monospace',
    fontWeight: '700',
    fontSize: '20px',
    letterSpacing: '0.04em',
  },
  tagline: {
    color: '#7A6E60',
    fontSize: '12px',
    fontFamily: 'monospace',
    letterSpacing: '0.08em',
    marginTop: '3px',
    fontWeight: '600',
  },
  divider: {
    height: '1px',
    background: '#BEB3A4',
    marginBottom: '28px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    color: '#7A6E60',
    fontSize: '11px',
    fontFamily: 'monospace',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    fontWeight: '700',
  },
  input: {
    background: '#F5F0E8',
    border: '1px solid #BEB3A4',
    borderRadius: '8px',
    padding: '11px 14px',
    color: '#0F1C2E',
    fontSize: '14px',
    fontFamily: 'monospace',
    outline: 'none',
    transition: 'border-color 0.15s',
  },
  error: {
    background: '#450A0A',
    border: '1px solid #EF4444',
    borderRadius: '8px',
    padding: '10px 14px',
    color: '#FCA5A5',
    fontSize: '12px',
    fontFamily: 'monospace',
    fontWeight: '600',
  },
  btn: {
    background: '#2563EB',
    border: 'none',
    borderRadius: '8px',
    padding: '12px',
    color: '#fff',
    fontFamily: 'monospace',
    fontWeight: '700',
    fontSize: '13px',
    letterSpacing: '0.05em',
    cursor: 'pointer',
    transition: 'opacity 0.15s',
    marginTop: '4px',
  },
};